namespace TabAurous.Stock {
    export namespace StockSheetService {
        export const baseUrl = 'Stock/StockSheet';


        export declare const enum Methods {

        }

    }
}
